'use client';

import {
  getMessageForDownServices,
  ReducedInstatusComponent,
} from '@/decodo/components/atoms/Instatus/utils';
import { TooltipProps } from '@/decodo/components/atoms/Tooltip/Tooltip';

import { defaultLocale } from '@/lib/i18n/dictionaries';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { apiCallStrapi } from '@/utils/fetch';
import { useEffect, useState } from 'react';
import { ServiceStatusComponent } from './ServiceStatus';

export type ServiceStatusProps = {
  size?: 'sm' | 'md';
  /** optional prop used to calculate text truncation */
  containerMaxWidth?: number;
  classNames?: {
    text?: string;
    button?: string;
    icon?: {
      inner?: string;
      outer?: string;
    };
    tooltip?: TooltipProps['classNames'];
  };
};

export const ServiceStatus = ({ classNames, size }: ServiceStatusProps) => {
  const [components, setComponents] = useState<
    ReducedInstatusComponent[] | null
  >([]);

  const { texts } = useTranslation();
  const { message, status } = getMessageForDownServices(
    components || [],
    texts
  );
  useEffect(() => {
    apiCallStrapi<ReducedInstatusComponent[]>({
      path: '/service-status',
      method: 'POST',
      body: { locale: defaultLocale },
    })
      .then((r) => {
        if (Array.isArray(r)) {
          setComponents(r as ReducedInstatusComponent[]);
        } else {
          setComponents(null);
        }
      })
      .catch((err) => {
        console.error(err);
        setComponents(null);
      });
  }, []);

  if (!components) return null;

  return (
    <ServiceStatusComponent
      message={message}
      classNames={classNames}
      size={size}
      status={status}
    />
  );
};
